import styled from 'styled-components';

export const AuthPageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5rem 2rem;
  min-height: calc(100vh - 80px); 
  background-color: ${({ theme }) => theme.colors.background};
`;

export const AuthFormCard = styled.div`
  width: 100%;
  max-width: 480px; // Um pouco maior para o cadastro
  padding: 3rem;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
`;

export const Title = styled.h2`
  text-align: center;
  margin-bottom: 2rem;
  font-size: 2rem;
  color: ${({ theme }) => theme.colors.secondary};
`;

export const SubtitleLink = styled.p`
  text-align: center;
  margin-top: 1.5rem;
  color: ${({ theme }) => theme.colors.light};

  a {
    color: ${({ theme }) => theme.colors.primary};
    font-weight: bold;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;